/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSS } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  className: string
  data?: any
  label?: string
}

const ChartsWidgetG3: React.FC<Props> = ({ className, label, data }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const chartInstanceRef = useRef<ApexCharts | null>(null)

  const refreshChart = () => {
    if (!chartRef.current || !data) {
      return
    }

    // Destroy existing chart instance
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy()
      chartInstanceRef.current = null
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    let chartData: any[] = []

    // Handle different data structures
    if (Array.isArray(data)) {
      chartData = data
    } else if (typeof data === 'object') {
      // Convert diversionCapacitiesBreakdown object to chart data
      chartData = Object.entries(data).map(([name, value]) => ({
        name: name,
        value: value as number
      })).filter(item => item.value > 0) // Only show items with values > 0
    } else {
      console.warn('Data format not supported for chart:', data)
      return
    }

    if (chartData.length === 0) {
      console.warn('No chart data available')
      return
    }

    // Extract series and labels
    const series = chartData.map((item: any) => {
      // Try to find a numerical value
      if (item.quantity !== undefined) return item.quantity
      if (item.quantitySupplied !== undefined) return item.quantitySupplied
      if (item['Post Industrial'] !== undefined) return item['Post Industrial']
      if (item['Post Consumer'] !== undefined) return item['Post Consumer']
      if (item.value !== undefined) return item.value
      // Fallback
      return 0
    })

    const labels = chartData.map((item: any) => {
      return item.name || item.pickupPointName || item.label || 'Unknown'
    })

    const options: ApexOptions = {
      series: series,
      chart: {
        type: 'pie',
        height: height,
        toolbar: {
          show: false
        }
      },
      legend: {
        position: 'bottom',
        show: false,
        fontSize: '12px',
        fontFamily: 'inherit',
        labels: {
          colors: mode === 'dark' ? '#fff' : '#000000'
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val: any) {
          return parseFloat(val).toFixed(1) + '%'
        },
        style: {
          fontSize: '12px',
          fontFamily: 'inherit',
          colors: ['#fff']
        }
      },
      labels: labels,
      // colors: ['#009EF7', '#12B886', '#F1416C', '#FFC700', '#7239EA', '#50CD89', '#E4E6EF'],
      colors: ["#4f45f5", "#ed6f43", "#ffe500", "#4f45f5"],

      stroke: {
        show: false
      },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            labels: {
              show: false
            }
          }
        }
      },
      tooltip: {
        style: {
          fontSize: '12px',
          fontFamily: 'inherit'
        },
        y: {
          formatter: function (val: any) {
            return val.toLocaleString()
          }
        }
      }
    }

    try {
      const chart = new ApexCharts(chartRef.current, options)
      chartInstanceRef.current = chart
      chart.render()
    } catch (error) {
      console.error('Error rendering chart:', error)
    }
  }

  useEffect(() => {
    refreshChart()

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy()
        chartInstanceRef.current = null
      }
    }
  }, [chartRef, mode, data])

  return (
    <div className={`card ${className}`}>
      {label && (
        <div className='card-header border-0 pt-5 '>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>{label}</span>
          </h3>
        </div>
      )}
      {/* <div className='card-body'>
        <div ref={chartRef} id='kt_charts_widget_5_chart' style={{ height: '230px' }}></div>
        <div className='card-header border-0 d-flex justify-content-center'>
          <h3 className='card-title mb-0'>
            <span className='card-label fw-bold fs-3'>Recycling Capacity</span>
          </h3>
        </div>
      </div> */}


      <div className='card-body'>
        <div className='d-flex flex-column align-items-center justify-content-center h-100'>
          <div ref={chartRef} id='kt_charts_widget_5_chart' style={{ height: '230px', width: '100%' }}></div>
          <div className='card-header border-0 d-flex justify-content-center'>
            <h3 className='card-title mb-0'>
              <span className='card-label fw-bold fs-3'>Plastic Keeper profile</span>
            </h3>
          </div>
        </div>
      </div>


    </div>
  )
}

export { ChartsWidgetG3 }